import { handleClickMoreBlockBtn } from '../parts/ui.js';

jQuery(document).ready(function () {
    jQuery('.product').on('click', '[data-more-btn]', handleClickMoreBlockBtn);

    const productGalleryThumbsSwiper = new Swiper('.product__gallery .gallery__thumbs', {
        spaceBetween: 20,
        slidesPerView: 3,

        navigation: {
            prevEl: '.product__gallery  .slider-navs__prev',
            nextEl: '.product__gallery  .slider-navs__next'
        }
    });

    new Swiper('.product__gallery .gallery__imgs', {
        thumbs: {
            swiper: productGalleryThumbsSwiper
        },

        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 20,
                pagination: {
                    el: '.product__gallery  .slider-navs__pag',
                    clickable: true
                }
            },
            577: {
                pagination: {}
            }
        }
    });
});
